import { NotificationEntity } from './../../enums/notification-enums';
import { UserNotificationResponseDto } from './../../models/responses/user-notification.response';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../dashboards/services/data.service';
import { AuthenticationResult } from '../../models/authentication-result';
import { UiStateStore } from '../../store/ui-state-store.service';
import { NotificationType } from '../../enums/notification-enums';
import { AccountTypes } from '../../models/AccountTypes';

@Component({
  selector: 'app-user-notifications',
  templateUrl: './user-notifications.component.html',
  styleUrls: ['./user-notifications.component.scss'],
})
export class UserNotificationsComponent implements OnInit {
  user: AuthenticationResult = null;
  userNotifications: UserNotificationResponseDto[] = [];

  constructor(
    private uiState: UiStateStore,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.uiState.authenticatedUser.subscribe((user) => {
      if (!user) {
        return;
      }

      this.user = user;
      this.getUserNotifications();
    });
  }

  getUserNotifications = () => {
    this.dataService
      .getUserNotifications(this.user.accountId)
      .subscribe((resp) => {
        this.userNotifications = resp;
      });
  };

  onNotificationClick = (notification: UserNotificationResponseDto) => {
    this.dataService
      .markNotificationRead(notification.notificationId)
      .subscribe((resp) => {
        if (resp) {
          this.userNotifications.forEach((x) => {
            if (x.notificationId == notification.notificationId) {
              notification.isRead = true;
            }
          });
        }
      });

    if (notification.notificationEntity === NotificationEntity.resume) {
      window.open(`/candidate/resume`, '_blank');
      return;
    }

    if (notification.notificationType === NotificationType.jobApproved || notification.notificationType === NotificationType.jobBlocked) {
      window.open(`/employer/manage-jobs`, '_blank');
      return;
    }

    var isCandidate = this.user.accountType == AccountTypes.Candidate;

    if (isCandidate) {
      if (notification.notificationType === NotificationType.jobInvite) {
        window.open(
          `/view-job-interest/${notification.recordId}/${notification.notifyFrom}`,
          '_blank'
        );
        return;
      }

      if (notification.notificationType === NotificationType.messageReceived) {
        window.open(
          `/view-job-interest/${notification.recordId}/${notification.notifyFrom}`,
          '_blank'
        );
        return;
      }
    } else {
      if (notification.notificationType === NotificationType.proposalReceived) {
        window.open(`/tasks-wizard/${notification.recordId}`, '_blank');
        return;
      }

      if (notification.notificationType === NotificationType.messageReceived) {
        window.open(`/tasks-wizard/${notification.recordId}`, '_blank');
        return;
      }
    }
  };
}
